/*
 *
 * Team actions
 *
 */

import {
  DEFAULT_ACTION,
  FETCH_TEAM,
  FETCH_TEAM_SUCCESS,
  FETCH_TEAM_FAILURE,
  FETCH_TEAM_APPS,
  FETCH_TEAM_APPS_SUCCESS,
  FETCH_TEAM_APPS_FAILURE,
  FETCH_SELECTED_APP_SUCCESS,
  ADD_TEAM_SOLUTION,
  ADD_TEAM_SOLUTION_SUCCESS,
  ADD_TEAM_SOLUTION_FAILURE,
  TOGGLE_ACTIVATE_TEAM_APP,
  TOGGLE_ACTIVATE_TEAM_APP_SUCCESS,
  TOGGLE_ACTIVATE_TEAM_APP_FAILURE,
  UPDATE_TEAM_APP,
  UPDATE_TEAM_APP_SUCCESS,
  UPDATE_TEAM_APP_FAILURE,
  UPDATE_TEAM,
  UPDATE_TEAM_SUCCESS,
  UPDATE_TEAM_FAILURE,
  DELETE_TEAM,
  DELETE_TEAM_SUCCESS,
  DELETE_TEAM_FAILURE,
  UNDELETE_TEAM,
  UNDELETE_TEAM_SUCCESS,
  UNDELETE_TEAM_FAILURE,
  CREATE_ASSESSMENT,
  CREATE_ASSESSMENT_SUCCESS,
  CREATE_ASSESSMENT_FAILURE,
  DELETE_ASSESSMENT,
  BULK_DELETE_ASSESSMENTS,
  DELETE_ASSESSMENT_SUCCESS,
  DELETE_ASSESSMENT_FAILURE,
  REFRESH_ASSESSMENT,
  REFRESH_ASSESSMENT_SUCCESS,
  REFRESH_ASSESSMENT_FAILURE,
  DOWNLOAD_TEAM_ASSESSMENT_DATA,
  IMPORT_ASSESSMENTS,
  IMPORT_ASSESSMENTS_SUCCESS,
  IMPORT_ASSESSMENTS_FAILURE,
  FETCH_IMPORTED_ASSESSMENTS,
  FETCH_IMPORTED_ASSESSMENTS_SUCCESS,
  FETCH_IMPORTED_ASSESSMENTS_FAILURE,
  RESET_SECURITY_CODE,
  RESET_SECURITY_CODE_SUCCESS,
  RESET_SECURITY_CODE_FAILURE,
  DISABLE_SECURITY_CODE,
  DISABLE_SECURITY_CODE_SUCCESS,
  DISABLE_SECURITY_CODE_FAILURE,
  FETCH_WORKFLOW_GROUPS,
  FETCH_WORKFLOW_GROUPS_SUCCESS,
  FETCH_WORKFLOW_GROUPS_FAILURE,
  RESET_WORKFLOW_GROUPS,
  ASSIGN_WORKFLOW_GROUP_USERS,
  ASSIGN_WORKFLOW_GROUP_USERS_SUCCESS,
  ASSIGN_WORKFLOW_GROUP_USERS_FAILURE,
  CHANGE_CURRENT_ASSIGNEE,
  CHANGE_CURRENT_ASSIGNEE_SUCCESS,
  CHANGE_CURRENT_ASSIGNEE_FAILURE,
  SEND_REMINDER,
  SEND_REMINDER_SUCCESS,
  SEND_REMINDER_FAILURE,
  DELETE_WORKFLOW_GROUP_USER,
  DELETE_WORKFLOW_GROUP_USER_FAILURE,
  DELETE_WORKFLOW_GROUP_USER_SUCCESS,
  FETCH_TEAM_WIDGETS,
  FETCH_TEAM_WIDGETS_SUCCESS,
  FETCH_TEAM_WIDGETS_FAILURE,
  EXECUTE_TEAM_WIDGET,
  EXECUTE_TEAM_WIDGET_SUCCESS,
  EXECUTE_TEAM_WIDGET_FAILURE,
  SET_CUSTOM_FILTERS,
  RESET_TEAM_WIDGETS,
  RESET_TEAM_ASSESSMENTS_STATE,
  RESET_CUSTOM_FILTERS,
  SELECT_TEAM_WIDGET,
  RESET_STATE,
  SET_ASSESSMENT_IS_SENSITIVE,
  SET_ASSESSMENT_IS_SENSITIVE_FAILURE,
  SET_ASSESSMENT_IS_SENSITIVE_SUCCESS,
  FETCH_TEAM_MEMBERSHIP,
  FETCH_TEAM_MEMBERSHIP_SUCCESS,
  FETCH_TEAM_MEMBERSHIP_FAILURE,
  FETCH_TEAM_SOLUTIONS,
  FETCH_TEAM_SOLUTIONS_SUCCESS,
  FETCH_TEAM_SOLUTIONS_FAILURE,
  FETCH_SOLUTIONS_PERMISSION,
  FETCH_SOLUTIONS_PERMISSION_SUCCESS,
  FETCH_SOLUTIONS_PERMISSION_FAILURE,
} from './constants';

export function fetchTeam(teamId) {
  return {
    type: FETCH_TEAM,
    teamId,
  };
}

export function fetchTeamSuccess(team) {
  return {
    type: FETCH_TEAM_SUCCESS,
    team,
  };
}

export function fetchTeamFailure(error) {
  return {
    type: FETCH_TEAM_FAILURE,
    error,
  };
}

export const fetchTeamSolutions = (teamId) => ({
  type: FETCH_TEAM_SOLUTIONS,
  teamId,
});
export const fetchTeamSolutionsSuccess = (solutions) => ({
  type: FETCH_TEAM_SOLUTIONS_SUCCESS,
  solutions,
});
export const fetchTeamSolutionsFailure = (error) => ({
  type: FETCH_TEAM_SOLUTIONS_FAILURE,
  error,
});

export const fetchSelectedAppSuccess = (app) => ({
  type: FETCH_SELECTED_APP_SUCCESS,
  app,
});

export const addTeamSolution = (teamId, solutionId) => ({
  type: ADD_TEAM_SOLUTION,
  teamId,
  solutionId,
});
export const addTeamSolutionSuccess = (solutions) => ({
  type: ADD_TEAM_SOLUTION_SUCCESS,
  solutions,
});
export const addTeamSolutionFailure = (error) => ({
  type: ADD_TEAM_SOLUTION_FAILURE,
  error,
});

export function toggleActivateTeamApp(activateType, teamId, solutionId) {
  return {
    type: TOGGLE_ACTIVATE_TEAM_APP,
    teamId,
    solutionId,
    activateType,
  };
}

export function toggleActivateTeamAppSuccess(solution) {
  return {
    type: TOGGLE_ACTIVATE_TEAM_APP_SUCCESS,
    solution,
  };
}

export function toggleActivateTeamAppFailure(error) {
  return {
    type: TOGGLE_ACTIVATE_TEAM_APP_FAILURE,
    error,
  };
}

export const updateTeamAppSuccess = (updatedTeamApp) => ({
  type: UPDATE_TEAM_APP_SUCCESS,
  updatedTeamApp,
});

export const updateTeamAppFailure = (error) => ({
  type: UPDATE_TEAM_APP,
  error,
});

export function updateTeam(teamId, updatedTeam) {
  return {
    type: UPDATE_TEAM,
    teamId,
    updatedTeam,
  };
}

export function updateTeamSuccess(team) {
  return {
    type: UPDATE_TEAM_SUCCESS,
    team,
  };
}

export function updateTeamFailure() {
  return {
    type: UPDATE_TEAM_FAILURE,
  };
}

export function deleteTeam(teamId) {
  return {
    type: DELETE_TEAM,
    teamId,
  };
}

export function deleteTeamSuccess() {
  return {
    type: DELETE_TEAM_SUCCESS,
  };
}

export function deleteTeamFailure(error) {
  return {
    type: DELETE_TEAM_FAILURE,
    error,
  };
}

export function createAssessment(props) {
  return {
    type: CREATE_ASSESSMENT,
    ...props,
  };
}

export function createAssessmentSuccess() {
  return {
    type: CREATE_ASSESSMENT_SUCCESS,
  };
}

export function createAssessmentFailure(error) {
  return {
    type: CREATE_ASSESSMENT_FAILURE,
    error,
  };
}

export function deleteAssessment(
  teamID,
  assessmentId,
  widgetID,
  pageSize,
  currentPage,
  sorting,
  filters
) {
  return {
    type: DELETE_ASSESSMENT,
    teamID,
    assessmentId,
    widgetID,
    pageSize,
    currentPage,
    sorting,
    filters,
  };
}

export function bulkDeleteAssessments(
  teamID,
  assessmentIds,
  widgetID,
  pageSize,
  currentPage,
  sorting,
  filters,
  allSelected
) {
  return {
    type: BULK_DELETE_ASSESSMENTS,
    teamID,
    assessmentIds,
    widgetID,
    pageSize,
    currentPage,
    sorting,
    filters,
    allSelected,
  };
}

export function deleteAssessmentSuccess() {
  return {
    type: DELETE_ASSESSMENT_SUCCESS,
  };
}

export function deleteAssessmentFailure(error) {
  return {
    type: DELETE_ASSESSMENT_FAILURE,
    error,
  };
}

export function refreshAssessment(assessmentId) {
  return {
    type: REFRESH_ASSESSMENT,
    assessmentId,
  };
}

export function refreshAssessmentSuccess() {
  return {
    type: REFRESH_ASSESSMENT_SUCCESS,
  };
}

export function refreshAssessmentFailure(error) {
  return {
    type: REFRESH_ASSESSMENT_FAILURE,
    error,
  };
}

export function downloadTeamAssessmentData(teamId, appId, includeAll) {
  return {
    type: DOWNLOAD_TEAM_ASSESSMENT_DATA,
    teamId,
    appId,
    includeAll,
  };
}

export function importAssessments(file) {
  return {
    type: IMPORT_ASSESSMENTS,
    file,
  };
}

export function importAssessmentsSuccess() {
  return {
    type: IMPORT_ASSESSMENTS_SUCCESS,
  };
}

export function importAssessmentsFailure(error) {
  return {
    type: IMPORT_ASSESSMENTS_FAILURE,
    error,
  };
}

export function fetchImportedAssessments(teamID, appID) {
  return {
    type: FETCH_IMPORTED_ASSESSMENTS,
    teamID,
    appID,
  };
}

export function fetchImportedAssessmentsSuccess(importedAssessments) {
  return {
    type: FETCH_IMPORTED_ASSESSMENTS_SUCCESS,
    importedAssessments,
  };
}

export function fetchImportedAssessmentsFailure(error) {
  return {
    type: FETCH_IMPORTED_ASSESSMENTS_FAILURE,
    error,
  };
}

export function resetSecurityCode(teamID, appID) {
  return {
    type: RESET_SECURITY_CODE,
    teamID,
    appID,
  };
}

export function resetSecurityCodeSuccess(appID, securityCode) {
  return {
    type: RESET_SECURITY_CODE_SUCCESS,
    appID,
    securityCode,
  };
}

export function resetSecurityCodeFailure(error) {
  return {
    type: RESET_SECURITY_CODE_FAILURE,
    error,
  };
}

export const disableSecurityCode = (teamId, appId) => ({
  type: DISABLE_SECURITY_CODE,
  teamId,
  appId,
});

export const disableSecurityCodeSuccess = (teamId, appId) => ({
  type: DISABLE_SECURITY_CODE_SUCCESS,
  teamId,
  appId,
});

export const disableSecurityCodeFailure = (error) => ({
  type: DISABLE_SECURITY_CODE_FAILURE,
  error,
});

export function fetchWorkflowGroups(teamID, versionID) {
  return {
    type: FETCH_WORKFLOW_GROUPS,
    teamID,
    versionID,
  };
}

export function fetchWorkflowGroupsSuccess(workflowGroups) {
  return {
    type: FETCH_WORKFLOW_GROUPS_SUCCESS,
    workflowGroups,
  };
}

export function fetchWorkflowGroupsFailure(error) {
  return {
    type: FETCH_WORKFLOW_GROUPS_FAILURE,
    error,
  };
}

export const resetWorkflowGroups = () => ({
  type: RESET_WORKFLOW_GROUPS,
});

export function assignWorkflowGroupUsers(groupID, teamID, versionID, users) {
  return {
    type: ASSIGN_WORKFLOW_GROUP_USERS,
    groupID,
    teamID,
    versionID,
    users,
  };
}

export function assignWorkflowGroupUsersSuccess(userMaps) {
  return {
    type: ASSIGN_WORKFLOW_GROUP_USERS_SUCCESS,
    userMaps,
  };
}

export function assignWorkflowGroupUsersFailure(error) {
  return {
    type: ASSIGN_WORKFLOW_GROUP_USERS_FAILURE,
    error,
  };
}

export function changeCurrentAssignee(
  assessmentId,
  userId,
  parallelBranchUUID,
  widgetId,
  pageSize,
  currentPage,
  sorting,
  filters,
  onSuccess
) {
  return {
    type: CHANGE_CURRENT_ASSIGNEE,
    assessmentId,
    userId,
    parallelBranchUUID,
    widgetId,
    pageSize,
    currentPage,
    sorting,
    filters,
    onSuccess,
  };
}

export function changeCurrentAssigneeSuccess(id, assignee) {
  return {
    type: CHANGE_CURRENT_ASSIGNEE_SUCCESS,
    id,
    assignee,
  };
}

export function changeCurrentAssigneeFailure(error) {
  return {
    type: CHANGE_CURRENT_ASSIGNEE_FAILURE,
    error,
  };
}

export function sendReminder(assessmentId) {
  return {
    type: SEND_REMINDER,
    assessmentId,
  };
}

export function sendReminderSuccess() {
  return {
    type: SEND_REMINDER_SUCCESS,
  };
}

export function sendReminderFailure(error) {
  return {
    type: SEND_REMINDER_FAILURE,
    error,
  };
}

export function setAssessmentIsSensitive(
  assessmentId,
  widgetId,
  isSensitive,
  pageSize,
  currentPage,
  sorting,
  filters
) {
  return {
    type: SET_ASSESSMENT_IS_SENSITIVE,
    assessmentId,
    widgetId,
    isSensitive,
    pageSize,
    currentPage,
    sorting,
    filters,
  };
}

export function setAssessmentIsSensitiveSuccess() {
  return {
    type: SET_ASSESSMENT_IS_SENSITIVE_SUCCESS,
  };
}

export function setAssessmentIsSensitiveFailure(error) {
  return {
    type: SET_ASSESSMENT_IS_SENSITIVE_FAILURE,
    error,
  };
}

export function deleteWorkflowGroupUser(
  membershipID,
  groupID,
  selectedVersion
) {
  return {
    type: DELETE_WORKFLOW_GROUP_USER,
    membershipID,
    groupID,
    selectedVersion,
  };
}

export function deleteWorkflowGroupUserSuccess(
  membershipID,
  groupID,
  selectedVersion
) {
  return {
    type: DELETE_WORKFLOW_GROUP_USER_SUCCESS,
    membershipID,
    groupID,
    selectedVersion,
  };
}

export function deleteWorkflowGroupUserFailure(error) {
  return {
    type: DELETE_WORKFLOW_GROUP_USER_FAILURE,
    error,
  };
}

export const fetchTeamWidgets = (teamID, appID, widgetID) => ({
  type: FETCH_TEAM_WIDGETS,
  teamID,
  appID,
  widgetID,
});

export const fetchTeamWidgetsSuccess = (widgets, widgetID) => ({
  type: FETCH_TEAM_WIDGETS_SUCCESS,
  widgets,
  widgetID,
});

export const fetchTeamWidgetsFailure = (error) => ({
  type: FETCH_TEAM_WIDGETS_FAILURE,
  error,
});

// TODO Refactor to use Widgets container
export const executeTeamWidget = ({
  teamID,
  widgetID,
  pageSize,
  currentPage,
  sorting,
  filters,
}) => ({
  type: EXECUTE_TEAM_WIDGET,
  teamID,
  widgetID,
  pageSize,
  currentPage,
  sorting,
  filters,
});

export const executeTeamWidgetSuccess = (executedWidget, definition) => ({
  type: EXECUTE_TEAM_WIDGET_SUCCESS,
  executedWidget,
  definition,
});

export const executeTeamWidgetFailure = (error) => ({
  type: EXECUTE_TEAM_WIDGET_FAILURE,
  error,
});

export const setCustomFilters = (widgetID, filters = []) => ({
  type: SET_CUSTOM_FILTERS,
  widgetID,
  filters,
});

export const resetTeamAssessmentsPage = () => ({
  type: RESET_TEAM_ASSESSMENTS_STATE,
});

export const resetTeamWidgets = () => ({
  type: RESET_TEAM_WIDGETS,
});

export const resetCustomFilters = () => ({
  type: RESET_CUSTOM_FILTERS,
});

export const selectTeamWidget = (widgetID) => ({
  type: SELECT_TEAM_WIDGET,
  widgetID,
});

export function resetState() {
  return {
    type: RESET_STATE,
  };
}

export const fetchTeamMembership = (teamID) => ({
  type: FETCH_TEAM_MEMBERSHIP,
  teamID,
});

export const fetchTeamMembershipSuccess = ({ teamRole, appPermissions }) => ({
  type: FETCH_TEAM_MEMBERSHIP_SUCCESS,
  teamRole,
  appPermissions,
});

export const fetchTeamMembershipFailure = (error) => ({
  type: FETCH_TEAM_MEMBERSHIP_FAILURE,
  error,
});

export const fetchSolutionsPermission = (solutions) => ({
  type: FETCH_SOLUTIONS_PERMISSION,
  solutions,
});

export const fetchSolutionsPermissionSuccess = (permissions) => ({
  type: FETCH_SOLUTIONS_PERMISSION_SUCCESS,
  permissions,
});

export const fetchSolutionsPermissionFailure = (error) => ({
  type: FETCH_SOLUTIONS_PERMISSION_FAILURE,
  error,
});
